import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import SignIn from './pages/AuthPages/SignIn';
import SignUp from './pages/AuthPages/SignUp';
import AppLayout from './layout/AppLayout';

import BulletDashboard from './pages/BulletDashboard';
import BookDelivery from './pages/BookDelivery';
import PaymentCallback from './pages/PaymentCallback';
import ProtectedRoute from './components/ProtectedRoute';
import ErrorBoundary from './components/ErrorBoundary';

const App: React.FC = () => {
  return (
    <ErrorBoundary>
      <Router>
        <Routes>
          {/* Auth Routes */}
          <Route path="/signin" element={<SignIn />} />
          <Route path="/signup" element={<SignUp />} />

          {/* Public Routes */}
          {/* <Route path="/book-delivery" element={<BookDelivery />} /> */}
          <Route path="/payment-callback" element={<PaymentCallback />} />

          {/* Protected Routes with AppLayout */}
          <Route path="/" element={
            <ProtectedRoute>
              <AppLayout />
            </ProtectedRoute>
          }>
            <Route index element={<BulletDashboard />} />
            <Route path="book-delivery" element={<BookDelivery />} />
            <Route path="dashboard" element={<BulletDashboard />} />
          </Route>

          {/* Fallback Route */}
          <Route path="*" element={<div>Page not found</div>} />
        </Routes>
      </Router>
    </ErrorBoundary>
  );
};

export default App;